import Vue from 'vue'
import VueRouter from 'vue-router'

//Public views.
import PublicProjects from '@/views/Public/Projects'
import PublicProject from '@/views/Public/Project'
import PublicAbout from '@/views/Public/About'
import PublicContests from '@/views/Public/Contests'
import PublicContest from '@/views/Public/Contest'
import PublicAccess from "@/views/Public/Access"
import PublicLogin from '@/views/Public/Login'
import PublicLoginBusiness from '@/views/Public/Login-Business'
import PublicProfile from '@/views/Public/Profile'
import PublicPage from '@/views/Public/Page'
import PublicVideoPortals from '@/views/Public/VideoPortals'

import PublicPrivacy from "@/views/Public/Privacy";
import PublicTermsUser from "@/views/Public/TermsUser";
import PublicTermsBusiness from "@/views/Public/TermsBusiness"
import CookiesPolicy from "@/views/Public/CookiesPolicy";
import AffiliateDisclaimer from "@/views/Public/AffiliateDisclaimer";

//User views.
import UserProfile from "@/views/User/Profile"
import UserProgress from "@/views/User/Progress/index.vue"
import UserProjectCreate from "@/views/User/ProjectCreate"
import UserProjectEdit from "@/views/User/ProjectEdit"
import UserProjects from "@/views/User/Projects"
import UserWallet from "@/views/User/Wallet"


//Business views
import BusinessContest from "@/views/Business/Contest"
import BusinessProfile from "@/views/Business/Profile"

//Admin views.

//import AdminDashboard from "@/views/Admin/Dashboard"
/*
import AdminUsers from "@/views/Admin/Users"
import AdminUser from "@/views/Admin/User"
import AdminProfileVideos from "@/views/Admin/ProfileVideos"
import AdminProjects from "@/views/Admin/Projects"
import AdminProject from "@/views/Admin/Project"
import AdminPayments from "@/views/Admin/Payments"
import AdminBusinessGeneral from "@/views/Admin/Business/General"
import AdminContests from "@/views/Admin/Business/Contests"
import AdminContest from "@/views/Admin/Business/Contest"
import AdminWallet from "@/views/Admin/Wallet"
import AdminSubscribers from "@/views/Admin/Subscribers"
import AdminContentPage from "@/views/Admin/Content/Page"
import AdminContentTutorials from "@/views/Admin/Content/Tutorials"
import AdminContentQualityCard from "@/views/Admin/Content/QualityCard"
import AdminEmailNotificationTemplates from "@/views/Admin/NotificationTemplates/Email"
import AdminWebsiteNotificationTemplates from "@/views/Admin/NotificationTemplates/Website"
*/
//import AdminContentAbout from "@/views/Admin/Content/About"
//import AdminContentGeneral from "@/views/Admin/Content/General"
//import AdminContentPages from "@/views/Admin/Content/Pages"

import eventBus from "../event-bus"

import store from '../store'

Vue.use(VueRouter)

const routes = [{
    path: '/privacy',
    name: 'PublicPrivacy',
    component: PublicPrivacy
  }, {
    path: '/cookies-policy',
    name: 'CookiesPolicy',
    component: CookiesPolicy
  }, {
    path: '/affiliate-disclaimer',
    name: 'AffiliateDisclaimer',
    component: AffiliateDisclaimer
  }, {
    path: '/terms',
    name: 'PublicTermsUser',
    component: PublicTermsUser
  }, {
    path: '/business-terms',
    name: 'PublicTermsBusiness',
    component: PublicTermsBusiness
  }, {
    path: '/',
    name: 'PublicProjects',
    component: PublicProjects
  }, {
    path: '/about',
    name: 'PublicAbout',
    component: PublicAbout
  }, {
    path: '/user/wallet',
    name: 'UserWallet',
    component: UserWallet,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  }, {
    path: '/admin',
    name: 'Admin',
    component: () => import( /* webpackChunkName: "Admin" */ '@/views/Admin'),
    meta: {
      requiresAuth: true,
      accountType: 'admin'
    },
    children: [{
      path: "",
      component: () => import( /* webpackChunkName: "AdminDashboard" */ '@/views/Admin/Dashboard'),
      name: "AdminDashboard"
    }, {
      path: "content/about",
      component: () => import( /* webpackChunkName: "AdminContentAbout" */ '@/views/Admin/Content/About'),
      name: "AdminContentAbout"
    }, {
      path: "content/general",
      component: () => import( /* webpackChunkName: "AdminContentGeneral" */ '@/views/Admin/Content/General'),
      name: "AdminContentGeneral"
    }, {
      path: "content/pages",
      component: () => import( /* webpackChunkName: "AdminContentPages" */ '@/views/Admin/Content/Pages'),
      name: "AdminContentPages"
    }, {
      path: "content/pages/:id",
      component: () => import( /* webpackChunkName: "AdminContentPage" */ '@/views/Admin/Content/Page'),
      name: "AdminContentPage"
    }, {
      path: "content/tutorials",
      component: () => import( /* webpackChunkName: "AdminContentTutorials" */ '@/views/Admin/Content/Tutorials'),
      name: "AdminContentTutorials"
    }, {
      path: "content/quality-card",
      component: () => import( /* webpackChunkName: "AdminContentQualityCard" */ '@/views/Admin/Content/QualityCard'),
      name: "AdminContentQualityCard"
    }, {
      path: "contests/:id",
      component: () => import( /* webpackChunkName: "AdminContest" */ '@/views/Admin/Business/Contest'),
      name: "AdminContest"
    }, {
      path: "contests",
      component: () => import( /* webpackChunkName: "AdminContests" */ '@/views/Admin/Business/Contests'),
      name: "AdminContests"
    }, {
      path: "business",
      component: () => import( /* webpackChunkName: "AdminBusinessGeneral" */ '@/views/Admin/Business/General'),
      name: "AdminBusinessGeneral"
    }, {
      path: "users/:id",
      component: () => import( /* webpackChunkName: "AdminUser" */ '@/views/Admin/User'),
      name: "AdminUser"
    }, {
      path: "users-general",
      component: () => import( /* webpackChunkName: "AdminUsersGeneral" */ '@/views/Admin/Users'),
      name: "AdminUsersGeneral"
    }, {
      path: "users",
      component: () => import( /* webpackChunkName: "AdminUsers" */ '@/views/Admin/Users'),
      name: "AdminUsers"
    }, {
      path: "profile-videos/:section",
      component: () => import( /* webpackChunkName: "AdminProfileVideos" */ '@/views/Admin/ProfileVideos'),
      name: "AdminProfileVideos"
    }, {
      path: "payments",
      component: () => import( /* webpackChunkName: "AdminPayments" */ '@/views/Admin/Payments'),
      name: "AdminPayments"
    }, {
      path: "wallet",
      component: () => import( /* webpackChunkName: "AdminWallet" */ '@/views/Admin/Wallet'),
      name: "AdminWallet"
    }, {
      path: "projects",
      component: () => import( /* webpackChunkName: "AdminProjects" */ '@/views/Admin/Projects'),
      name: "AdminProjects"
    }, {
      path: "projects/contests",
      component: () => import( /* webpackChunkName: "AdminProjectsContests" */ '@/views/Admin/Projects'),
      name: "AdminProjectsContests"
    }, {
      path: "projects/:id",
      component: () => import( /* webpackChunkName: "AdminProject" */ '@/views/Admin/Project'),
      name: "AdminProject"
    }, {
      path: "notification-templates/email",
      component: () => import( /* webpackChunkName: "AdminEmailNotificationTemplates" */ '@/views/Admin/NotificationTemplates/Email'),
      name: "AdminEmailNotificationTemplates"
    }, {
      path: "notification-templates/website",
      component: () => import( /* webpackChunkName: "AdminWebsiteNotificationTemplates" */ '@/views/Admin/NotificationTemplates/Website'),
      name: "AdminWebsiteNotificationTemplates"
    }, {
      path: "subscribers",
      component: () => import( /* webpackChunkName: "AdminSubscribers" */ '@/views/Admin/Subscribers'),
      name: "AdminSubscribers"
    }]
  }, {
    path: '/access',
    name: 'PublicAccess',
    component: PublicAccess
  }, {
    path: '/login',
    name: 'PublicLogin',
    component: PublicLogin
  }, {
    path: '/login-business',
    name: 'PublicLoginBusiness',
    component: PublicLoginBusiness
  }, {
    path: '/contests',
    name: 'PublicContests',
    component: PublicContests
  }, {
    path: '/contests/:id/:title',
    name: 'PublicContest',
    component: PublicContest
  }, {
    path: '/contests/:id',
    name: 'PublicContest',
    component: PublicContest
  },
  {
    path: '/business/profile',
    name: 'BusinessProfile',
    component: BusinessProfile,
    meta: {
      requiresAuth: true,
      accountType: 'business'
    }
  },
  {
    path: '/business/contest/:id',
    name: 'BusinessContest',
    component: BusinessContest,
    meta: {
      requiresAuth: true,
      accountType: 'business'
    }
  },
  {
    path: '/user/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  },
  {
    path: '/user/progress',
    name: 'UserProgress',
    component: UserProgress,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  },
  {
    path: '/user/projects',
    name: 'UserProjects',
    component: UserProjects,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  },
  {
    path: '/profile/:uid',
    name: 'PublicProfile',
    component: PublicProfile
  },
  {
    path: '/user/projects/create',
    name: 'UserProjectCreate',
    component: UserProjectCreate,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  },
  {
    path: '/user/projects/:id',
    name: 'UserProjectEdit',
    component: UserProjectEdit,
    meta: {
      requiresAuth: true,
      accountType: 'user'
    }
  },
  {
    path: '/project/:id/:title',
    name: 'PublicProject',
    component: PublicProject
  },
  {
    path: '/project/:id',
    name: 'PublicProject',
    component: PublicProject
  },
  {
    path: '/video-portals',
    name: 'PublicVideoPortals',
    component: PublicVideoPortals
  },
  {
    path: '/:slug',
    name: 'PublicPage',
    component: PublicPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes
})

router.afterEach(function (to) {
  if (to.hash.includes("create-contest")) {
    eventBus.$emit('create_contest')
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['account/isLoggedIn']) {
      next()
      return
    }
    store.commit('account/set_continue', to);
    next('/access')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.accountType) {
    if (store.getters['account/type'] === to.meta.accountType) {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})


router.beforeEach((to, from, next) => {
  store.commit('projects/hide_search')
  next()
})


export default router